module.exports = __webpack_public_path__ + "static/img/icon h pptys.d1bf584e.svg";